import type { LucideProps } from 'lucide-react'

export function TreeIcon({ className, ...props }: LucideProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            {...props}
        >
            <rect width="8" height="8" x="3" y="3" rx="2" />
            <path d="M7 11v4a2 2 0 0 0 2 2h4" />
            <rect width="8" height="8" x="13" y="13" rx="2" />
        </svg>
    )
}

export function TreeIconGradient({ className, ...props }: LucideProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            className={className}
            {...props}
        >
            <defs>
                <linearGradient id="tree-icon-gradient" x1="3" y1="3" x2="21" y2="21" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#2563EB" /> {/* blue-600 */}
                    <stop offset="1" stopColor="#9333EA" /> {/* purple-600 */}
                </linearGradient>
            </defs>
            <rect width="8" height="8" x="3" y="3" rx="2" fill="url(#tree-icon-gradient)" stroke="none" />
            <path d="M7 11v4a2 2 0 0 0 2 2h4" stroke="url(#tree-icon-gradient)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
            <rect width="8" height="8" x="13" y="13" rx="2" fill="url(#tree-icon-gradient)" stroke="none" />
        </svg>
    )
}
